import { StyleSheet } from 'react-native';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    content: {
        paddingVertical: Layout.gutter,
        paddingHorizontal: Layout.gutterLarge,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    itemSeparator: {
        borderTopWidth: 1,
        borderTopColor: Colors.border
    },
    label: {
        flex: 1,
        minHeight: 22,
        marginLeft: 10,
        color: Colors.darker,
        fontSize: 16
    },
    icon: {
        width: 40
    }
});
